import axios from 'axios'
import qs from 'qs'
import { notification } from 'ant-design-vue'

import store from '@/store'
import router from '@/router'
import errMsg from './axiosErrMsg.json'

const Axios = axios.create()

// Axios请求拦截器
Axios.interceptors.request.use(config => {
  config.url = config.url + '?s=' + new Date().getTime()

  if (config.method === 'get') {
    // 处理 GET 请求传递数组参数的情况
    config.paramsSerializer = function(params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }
  return config
})

// 响应拦截器
Axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error && error.response) {
      const lang = store.state.lang
      switch (error.response.status) {
        case 400:
          showNotification({
            message: errMsg[lang].badRequest,
            description: parseAxiosError(error)
          })
          break

        case 401:
          showNotification({
            message: errMsg[lang].unauth,
            description: errMsg[lang].unauthDesc,
            duration: null,
            btn: h => {
              return creatReloginBtn(h, lang)
            },
            onClose: handleRelogin
          })
          // router.replace({name: '/user/login'})
          break

        case 403:
          showNotification({
            message: errMsg[lang].forbidden,
            description: parseAxiosError(error)
          })
          break

        case 404:
          showNotification({
            message: errMsg[lang].notFound,
            description: parseAxiosError(error)
          })
          break

        case 408:
          showNotification({
            message: errMsg[lang].requestTimeout,
            description: parseAxiosError(error)
          })
          break

        case 500:
          showNotification({
            message: errMsg[lang].serverError,
            description: parseAxiosError(error)
          })
          break

        case 501:
          showNotification({
            message: errMsg[lang].notImplemented,
            description: parseAxiosError(error)
          })
          break

        case 502:
          showNotification({
            message: errMsg[lang].badGateway,
            description: parseAxiosError(error)
          })
          break

        case 503:
          showNotification({
            message: errMsg[lang].serviceUnavailable,
            description: parseAxiosError(error)
          })
          break

        case 504:
          showNotification({
            message: errMsg[lang].gatewayTimeout,
            description: parseAxiosError(error)
          })
          break

        case 505:
          showNotification({
            message: errMsg[lang].httpVersionNotSupported,
            description: parseAxiosError(error)
          })
          break

        default:
      }
    }
    return Promise.reject(error)
  }
)

function parseAxiosError(error) {
  // console.log(error.response.data);
  // console.log(error.response.status);
  // console.log(error.response.headers);
  // console.log(error.request);
  // console.log(error.message);
  if (error.response) {
    return (error.response.data || {}).message || ''
  } else if (error.request) {
    return error.request
  } else {
    return error.message
  }
}

function showNotification(data) {
  notification.close('requestError')
  notification.error({
    key: 'requestError',
    ...data
  })
}

function creatReloginBtn(h, lang) {
  return h(
    'a-button',
    {
      props: {
        type: 'primary',
        size: 'small'
      },
      on: { click: handleRelogin }
    },
    errMsg[lang].unauthBtn
  )
}

function handleRelogin() {
  try {
    store.commit('resetKeepAliveInclude')
    store.commit('resetSysRepeatDataNum')

    store.commit('refreshUserInfo', null)
    store.commit('setEnumsData', {})
    store.commit('setOrgTreeSourceData', [])

    router.push({ path: '/user' })
    notification.close('requestError')
  } catch (error) {}

}

export default Axios
